import {defineStore} from 'pinia'
import DataSource from "devextreme/data/data_source";
import { ref} from "vue";


import {useGajiModel} from "@/stores/models/gaji-model";
//import {useFormaterStore} from "@/store/utility/formatter-store";

export const useGajiStore = defineStore(
    'gajiStore',
    () => {
        const isLoading = ref(false);
        const dataSourceDireksi = ref(
            new DataSource({
                requireTotalCount: true,
                store: useGajiModel().direksiCustomStore,
               
            })
        );
        const dataSourceTetap = ref(
            new DataSource({
                requireTotalCount: true,
                store: useGajiModel().tetapCustomStore,
               
            })
        );

        const dataSourceHonor = ref(
            new DataSource({
                requireTotalCount: true,
                store: useGajiModel().honorCustomStore,
               
            })
        );

        const dataSourceKontrak = ref(
            new DataSource({
                requireTotalCount: true,
                store: useGajiModel().kontrakCustomStore,
               
            })
        );
        
        const state = ref(true);
        const onMuatButtonClick =()=>{
            state.value = false;
            dataSourceDireksi.value.reload();
        };

        const initialized = ()=>{     
            dataSourceDireksi.value.reload();
        };

        return {
            dataSourceDireksi,
            dataSourceHonor,
            dataSourceTetap,
            dataSourceKontrak,
            isLoading,
            onMuatButtonClick,
            initialized,
            state

        }
    }
);